var map = {
	".": "R9OT",
	"./": "R9OT",
	"./01_create_listenKey": "KCrj",
	"./01_create_listenKey.json": "KCrj",
	"./02_put_listenKey": "lKnG",
	"./02_put_listenKey.json": "lKnG",
	"./03_delete_listenKey": "+Xv4",
	"./03_delete_listenKey.json": "+Xv4",
	"./index": "R9OT",
	"./index.js": "R9OT"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "U4UH";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/listenKey ^.*$
// module id = U4UH
// module chunks = 3